var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promote-tracking-status"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.data.body, {trackingId: _vm.data.trackingId}))}})])}
var staticRenderFns = []

export { render, staticRenderFns }